var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PromotionHeader',{attrs:{"header":"จัดการโปรโมชั่นสินค้าใกล้หมดอายุ","img_header":_vm.header_image,"link_back":"stock/storage/expirestorage"}}),_c('Promotion_manage_exp')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }